import Notifications from "../../../../components/settings/Notifications/Notifications";
import { MeDocument, useUpdateNotificationsSettingMutation } from "@axio/graphql/generated/graphql";
import { useState } from "react";
import { useAuth } from "../../../../hooks/useAuth";

function NotificationsContainer() {
  const [errorUpdatingNotifications, setErrorUpdatingNotifications] = useState("");
  const { meData } = useAuth();
  const [updateNotificationsSetting] = useUpdateNotificationsSettingMutation({
    refetchQueries: [
      {
        query: MeDocument,
      },
    ],
  });

  const handleDailyEmailOptInPress = async () => {
    setErrorUpdatingNotifications("");
    try {
      await updateNotificationsSetting({
        variables: {
          dailyEmailOptIn: !meData?.me?.dailyEmailOptIn,
        },
      });
    } catch (error) {
      console.error("failed", error);
      setErrorUpdatingNotifications(error);
    }
  };

  return (
    <Notifications
      errorMessage={errorUpdatingNotifications}
      isEnabled={meData?.me?.dailyEmailOptIn}
      onChange={handleDailyEmailOptInPress}
      buttonText={"Receive daily plan email"}
    />
  );
}

export default NotificationsContainer;
